var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrpdwicon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_955_3853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.474 19.9876L20.479 19.9868V12.6608C20.479 9.07691 19.7074 6.31616 15.5176 6.31616C13.5034 6.31616 12.1518 7.42146 11.5999 8.46933H11.5417V6.65075H7.56909V19.9868H11.7056V13.3833C11.7056 11.6446 12.0352 9.96332 14.1884 9.96332C16.3099 9.96332 16.3416 11.9475 16.3416 13.4948V19.9876H20.474Z",
    fill: "#E6A358"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.833496 6.65161H4.97504V19.9876H0.833496V6.65161Z",
    fill: "#E6A358"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.90212 0.0123291C1.57792 0.0123291 0.503418 1.08683 0.503418 2.41103C0.503418 3.73523 1.57792 4.8322 2.90212 4.8322C4.22631 4.8322 5.30082 3.73523 5.30082 2.41103C5.29999 1.08683 4.22548 0.0123291 2.90212 0.0123291Z",
    fill: "#E6A358"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_955_3853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9753,
    height: 19.9753,
    fill: "white",
    transform: "translate(0.503418 0.0123291)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrpdwicon2);
export default __webpack_public_path__ + "static/media/drpdwicon2.80270471b86e8642c388e9036d915a63.svg";
export { ForwardRef as ReactComponent };